import { isPlatform, createGesture, useIonRouter } from '@ionic/react';
import React, { useEffect } from 'react';
import { pageAnimation } from '..';

export const useSwipeBackGesture = (
  ref: React.MutableRefObject<Node | HTMLDivElement | undefined | null>,
  cb?: () => void
) => {
  const navigation = useIonRouter();

  useEffect(() => {
    if (!isPlatform('desktop') && ref.current) {
      const gesture = createGesture({
        el: ref.current,
        threshold: 30,
        gestureName: 'swipe-back',
        direction: 'x',
        maxAngle: 15,
        onEnd: (ev) => {
          if (ev.deltaX > 0) {
            if (cb instanceof Function) return cb();
            navigation.goBack((baseEl, opts) => pageAnimation(baseEl, opts, true));
          }
        },
      });
      gesture.enable();
      return () => gesture.destroy();
    }
  }, [navigation]);
};
